<template>
    <Interval
        :title="$t('tithi' + number) + ' (' + tithi.lord + ')'"
        :description="tithi.number + (tithi.number != shortNumber ? '(' + shortNumber + ')' : '') + $t('tithi') 
          + ' / ' + formatTime(tithi.start) + ' - ' + formatTime(tithi.end)
          + ' / ' + $t(tithi.type) + ' / ' + $t(tithi.element)"
        :bg="'bg-'+tithi.lord.toLowerCase()"
        :start="tithi.start" :length="tithi.length" :favorable="tithi.favorable"
        :scale="scale" :zero="zero" :visibleLeft="visibleLeft"
    />
</template>

<script>
import Interval from '@/components/panchanga/Interval'
import { TimeFormatMixin } from '@/components/visual/TimeFormatMixin'
export default {
  props: ['tithi', 'scale', 'zero', 'visibleLeft'],
  components: { Interval },
  mixins: [TimeFormatMixin],
  computed: {
    shortNumber() {
      var number = this.tithi.number % 5
      if (number == 0)
        number = 5
      return number
    },
    number() {
      var number = this.tithi.number % 15
      if (number == 0)
        number = this.tithi.number
      return number
    }
  },
}
</script>

<i18n locale="ru" lang="yaml">
  tithi: " л.с."
  tithi1: "Пратипат"
  tithi2: "Двития"
  tithi3: "Трития"
  tithi4: "Чатуртхи"
  tithi5: "Панчами"
  tithi6: "Шашти"
  tithi7: "Саптами"
  tithi8: "Аштами"
  tithi9: "Навами"
  tithi10: "Дашами"
  tithi11: "Экадаши"
  tithi12: "Двадаши"
  tithi13: "Трайодаши"
  tithi14: "Чатурдаши"
  tithi15: "Пурнима"
  tithi30: "Амавасья"
  nanda: "Радующие"
  bhadra: "Благоприятные"
  jaya: "Победоносные"
  rikta: "Жесткие"
  purna: "Полные"
  space: "Пространство"
  air: "Воздух"
  fire: "Огонь"
  water: "Вода"
  earth: "Земля"
</i18n>

<i18n locale="en" lang="yaml">
  tithi: "'s moon day"
  tithi1: "Pratipat"
  tithi2: "Dvitia"
  tithi3: "Tritia"
  tithi4: "Chaturthi"
  tithi5: "Panchami"
  tithi6: "Shashti"
  tithi7: "Saptami"
  tithi8: "Ashtami"
  tithi9: "Navami"
  tithi10: "Dashami"
  tithi11: "Ekadashi"
  tithi12: "Dvadashi"
  tithi13: "Triodashi"
  tithi14: "Chaturdashi"
  tithi15: "Purnima"
  tithi30: "Amavasya"
  nanda: "Happiness"
  bhadra: "Blessed"
  jaya: "Victorious"
  rikta: "Emptiness"
  purna: "Completion"
  space: "Space"
  air: "Air"
  fire: "Fire"
  water: "Water"
  earth: "Earth"
</i18n>
